import EntryTest from "./EntryTest";

export default EntryTest;
